import axios from "axios"

const getActivityAll = (activityId, customerId) => {
	return axios.get(`/prod-api/biz/activity/all/${activityId}`, {
		params: {customerId}
	}).then(res => {
		return res.data
	})
}

const register = (data) => {
	return axios.post('/prod-api/biz/customer/register', {
		...data
	}).then(res => {
		return res.data
	})
}

const login = (data) => {
	return axios.post('/prod-api/biz/customer/login', {
		...data
	}).then(res => {
		return res.data
	})
}

//  绑定销售记录
const bindRecordId = (recordId, customerId) => {
	return axios.post(`/prod-api/biz/record/bind/${recordId}/${customerId}`).then(res => {
		return res.data
	})
}

const userDraw = (activityId, customerId) => {
	return axios.post(`/prod-api/biz/activity/draw/${activityId}/${customerId}`).then(res => {
		return res.data
	})
}
const listByIds = (ossId) => {
	return axios.get(`/prod-api/system/oss/listByIds/${ossId}`).then(res => {
		return res.data
	})
}
export default {
	getActivityAll,
	register,
	login,
	bindRecordId,
	userDraw,
	listByIds
}
